class DeliveryInfoController {
    /*@ngInject*/
    constructor($log, $rootScope, CommonService) {
        $log.debug('DeliveryInfoController initialized');
        this.$log = $log;
        this.deliveryDate = null;
        this.commonService = CommonService;

        $rootScope.$on('personalizeRequestSuccess', () => {
            this.deliveryDate = this.commonService.getPersonalizeRequestResponse().deliveryDate;
        });
    }

    getDeliveryDate() {
        return this.deliveryDate;
    }
}

export default DeliveryInfoController;
